import { render } from "./ProductCalcV2.vue?vue&type=template&id=abda12a8&scoped=true"
import script from "./ProductCalcV2.vue?vue&type=script&lang=js"
export * from "./ProductCalcV2.vue?vue&type=script&lang=js"

import "./ProductCalcV2.vue?vue&type=style&index=0&id=abda12a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abda12a8"]])

export default __exports__